<script>
import {mapGetters} from "vuex";
import Loading from "@/components/Loading.vue";

export default {
  name: "AttendeeEventPreferences",
  components: {Loading},
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    attendeePreferenceAnalytics() {
      return this.currentEvent.analyticsData.attendeeEventPreferences;
    },
    noOfEnableConnectionRequests() {
      return this.attendeePreferenceAnalytics.connectionReqEnabled;
    },
    noOfDisableConnectionRequests() {
      return this.attendeePreferenceAnalytics.connectionReqDisabled;
    },
    noOfEnableChatRequests() {
      return this.attendeePreferenceAnalytics.chatEnabled;
    },
    noOfDisableChatRequests() {
      return this.attendeePreferenceAnalytics.chatDisabled;
    },
    noOfEnableMatchMaking() {
      return this.attendeePreferenceAnalytics.matchMakingEnabled;
    },
    noOfDisableMatchMaking() {
      return this.attendeePreferenceAnalytics.matchMakingDisabled;
    },
  }
}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true" class="pb-2">
      <v-card-title>Attendee’s event preferences</v-card-title>
<!--      <div v-if="this.eventAttendees === null || this.eventAttendees === undefined">
        <Loading />
      </div>-->
      <div>
      <v-card-subtitle class="py-0">
          <span style="color: #96A4B9">The number of attendees who have used, enabled or disabled their event preferences based on the number of attendees joined.</span>

      </v-card-subtitle>
<!--      <div class="py-4">
        <v-divider />
      </div>-->
      <v-col cols="12">
        <v-row>
          <v-col cols="6" md="5">
            <span>Connection Requests</span>
            <div class="enabledDiv">
              <v-row class="contentRow">
                <div>Enabled</div>
                <div class="valueText"> {{ noOfEnableConnectionRequests}}</div>
              </v-row>
            </div>
            <div class="disabledDiv">
              <v-row class="contentRow">
                <div>Disabled</div>
                <div class="valueText"> {{noOfDisableConnectionRequests}} </div>
              </v-row>
            </div>
          </v-col>
          <v-col cols="6" md="5">
            <span>Chat requests</span>
            <div class="enabledDiv">
              <v-row class="contentRow">
                <span>Enabled</span>
                <div class="valueText">{{ noOfEnableChatRequests }}</div>
              </v-row>
            </div>
            <div class="disabledDiv">
              <v-row class="contentRow">
                <div>Disabled</div>
                <div class="valueText">{{ noOfDisableChatRequests }}</div>
              </v-row>
            </div>
          </v-col>
          <v-col cols="6" md="5">
            <span>Match-making</span>
            <div class="enabledDiv">
              <v-row class="contentRow">
                <div>Selected</div>
                <div class="valueText">{{noOfEnableMatchMaking}}</div>
              </v-row>
            </div>
            <div class="disabledDiv">
              <v-row class="contentRow">
                <div>Not selected</div>
                <div class="valueText"> {{ noOfDisableMatchMaking}}</div>
              </v-row>
            </div>
          </v-col>
        </v-row>
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

.valueText {
  color: #516077;
  font-weight: 500;
}


.enabledDiv {
  background-color: #36B37E14;
  color: #36B37E;
  border-radius: 6px;
  margin-right: 10px;
  margin-bottom: 8px;
  margin-top: 12px;
}

.disabledDiv {
  background-color: #C5CDDA4D;
  color: #96A4B9;
  border-radius: 6px;
  margin-right: 10px;
}

.contentRow {
  padding: 4px 12px;
  justify-content: space-between;
  margin: auto;

}

</style>